<template>
  <div class="ap-shell">
    <div v-if="userStore.isViewingAsCoach" class="ap-viewas">
      <span class="ap-viewas__text">
        {{ $t('viewAs.banner', { coach: userStore.actingCoachName }) }}
      </span>
      <button type="button" class="ap-viewas__exit" @click="exitViewAs">
        {{ $t('viewAs.exit') }}
      </button>
    </div>
    <PhTopNav @logout="onLogout" />
    <main :key="$route.fullPath" class="ap-main">
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import PhTopNav from '@/components/ph/PhTopNav.vue'
import { auth } from '@/services/firebase'
import { useUserStore } from '@/stores/user-store'

const router = useRouter()
const userStore = useUserStore()

async function onLogout() {
  try {
    await auth.signOut()
  } catch {
    /* ignore */
  }
  userStore.clearUser()
  router.push({ name: 'login' })
}

function exitViewAs() {
  userStore.clearActingCoach()
  router.push({ name: 'coaches' })
}
</script>

<style scoped>
.ap-shell {
  min-height: 100vh;
  background: var(--ph-bg);
  color: var(--ph-text);
}
.ap-viewas {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 8px 16px;
  background: var(--ph-accent);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.ap-viewas__text {
  letter-spacing: -0.1px;
}
.ap-viewas__exit {
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 999px;
  cursor: pointer;
}
.ap-viewas__exit:hover {
  background: rgba(255, 255, 255, 0.28);
}
.ap-main {
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 28px 80px;
  animation: fadeIn 220ms ease;
}
</style>
